import {omneticApi} from '@dms/api/base';

import {
  CreateServiceCaseActivityApiArg,
  CreateServiceCaseActivityApiResponse,
  CreateServiceCaseActivityApiResponseSchema,
  CreateServiceCaseActivityRequestBodySchema,
  GetServiceCaseActivityApiArg,
  GetServiceCaseActivityApiArgSchema,
  GetServiceCaseActivityApiResponse,
  GetServiceCaseActivityApiResponseSchema,
  GetServiceCaseCustomerMessagesApiArg,
  GetServiceCaseCustomerMessagesApiArgSchema,
  GetServiceCaseCustomerMessagesApiResponse,
  GetServiceCaseCustomerMessagesApiResponseSchema,
  GetServiceCaseUpcomingTasksApiArg,
  GetServiceCaseUpcomingTasksApiArgSchema,
  GetServiceCaseUpcomingTasksApiResponse,
  GetServiceCaseUpcomingTasksApiResponseSchema,
} from './types';

export const serviceCaseActivityApi = omneticApi.injectEndpoints({
  endpoints: (build) => ({
    getServiceCaseActivity: build.query<
      GetServiceCaseActivityApiResponse,
      GetServiceCaseActivityApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/workshop/service-case/${queryArg.serviceCaseId}/activity`,
        queryArg,
      }),
      providesTags: (_result, _error, queryArg) => [
        {type: 'ServiceCaseActivity', id: queryArg.serviceCaseId},
      ],
      extraOptions: {
        requestSchema: GetServiceCaseActivityApiArgSchema,
        responseSchema: GetServiceCaseActivityApiResponseSchema,
      },
    }),
    createServiceCaseActivity: build.mutation<
      CreateServiceCaseActivityApiResponse,
      CreateServiceCaseActivityApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/workshop/service-case/${queryArg.serviceCaseId}/activity`,
        method: 'POST',
        body: queryArg.createServiceCaseActivityRequestBody,
        queryArg,
      }),
      invalidatesTags: (_result, _error, queryArg) => [
        {type: 'ServiceCaseActivity', id: queryArg.serviceCaseId},
      ],
      extraOptions: {
        requestSchema: CreateServiceCaseActivityRequestBodySchema,
        responseSchema: CreateServiceCaseActivityApiResponseSchema,
      },
    }),
    getServiceCaseUpcomingTasks: build.query<
      GetServiceCaseUpcomingTasksApiResponse,
      GetServiceCaseUpcomingTasksApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/workshop/service-case/${queryArg.serviceCaseId}/upcoming-tasks`,
        queryArg,
      }),
      providesTags: (_result, _error, queryArg) => [
        {type: 'ServiceCaseUpcomingTasks', id: queryArg.serviceCaseId},
      ],
      extraOptions: {
        requestSchema: GetServiceCaseUpcomingTasksApiArgSchema,
        responseSchema: GetServiceCaseUpcomingTasksApiResponseSchema,
      },
    }),
    getServiceCaseCustomerMessages: build.query<
      GetServiceCaseCustomerMessagesApiResponse,
      GetServiceCaseCustomerMessagesApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/workshop/service-case/${queryArg.serviceCaseId}/customer-message`,
        params: {limit: queryArg.limit, offset: queryArg.offset},
        queryArg,
      }),
      providesTags: (_result, _error, queryArg) => [
        {type: 'ServiceCaseCustomerMessages', id: queryArg.serviceCaseId},
      ],
      extraOptions: {
        requestSchema: GetServiceCaseCustomerMessagesApiArgSchema,
        responseSchema: GetServiceCaseCustomerMessagesApiResponseSchema,
      },
    }),
  }),
});

export const {
  useGetServiceCaseActivityQuery,
  useCreateServiceCaseActivityMutation,
  useGetServiceCaseUpcomingTasksQuery,
  useGetServiceCaseCustomerMessagesQuery,
} = serviceCaseActivityApi;
